import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PATH_TITLE_OVERRIDES: Record<string, string> = {
  '/os/meetings': 'Meetings',
};

/** Namespace prefixes stripped from tab titles (structural, not meaningful) */
const HIDDEN_SEGMENTS = new Set(['os', 'erp', 'crm']);

/** Segments that should use a specific casing instead of Title Case */
const SEGMENT_LABELS: Record<string, string> = {
  kpis: 'KPIs',
  vto: 'VTO',
  rma: 'RMA',
  carm: 'CARM',
};

/**
 * Sets document.title based on the current route pathname.
 * Converts "/operations/sim-cards" → "Operations - Sim Cards | ATEK"
 */
export function usePageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const override = PATH_TITLE_OVERRIDES[pathname];
    if (override) {
      document.title = `${override} | ATEK`;
      return;
    }

    const segments = pathname.split('/').filter(Boolean);

    if (segments.length === 0) {
      document.title = 'ATEK';
      return;
    }

    // Skip dynamic ID segments (MongoDB ObjectIds, UUIDs, numeric IDs)
    // Skip namespace prefixes (os, erp)
    const meaningful = segments.filter(
      (s) =>
        !HIDDEN_SEGMENTS.has(s) &&
        !/^[0-9a-f]{24}$/.test(s) &&
        !/^[0-9a-f-]{36}$/.test(s) &&
        !/^\d+$/.test(s)
    );

    const title = meaningful
      .map((s) =>
        SEGMENT_LABELS[s] ??
        s
          .split('-')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ')
      )
      .join(' - ');

    document.title = title ? `${title} | ATEK` : 'ATEK';
  }, [pathname]);
}
